import { formatCurrency } from '../../../utils/datetime';

const TillSummary = ({ completed, currency }) => {
  const total = completed.reduce(
    (sum, appt) => sum + (Number(appt.price) || Number(appt.service?.price) || 0),
    0
  );
  const online = completed.filter((appt) => appt.source === 'booking_link').length;
  const walkInish = completed.length - online;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-2xl font-light text-ink-900">Till &amp; cash up</h2>
        <p className="mt-1 text-sm text-ink-700/80">
          Running total from completed visits today. Full payment rails come next.
        </p>
      </div>

      <div className="bg-ink-900 p-6 text-sand-50 sm:p-8">
        <p className="text-xs uppercase tracking-[0.22em] text-saffron-400">Taken today</p>
        <p className="mt-3 font-display text-4xl font-light tracking-tight sm:text-5xl">
          {formatCurrency(total, currency)}
        </p>
        <p className="mt-3 text-sm text-sand-200/75">
          {completed.length} completed visit{completed.length === 1 ? '' : 's'}
        </p>
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        <div className="bg-sand-50 px-5 py-4 ring-1 ring-ink-900/10">
          <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-600/60">
            Online bookings
          </p>
          <p className="mt-2 font-display text-3xl font-light text-ink-900">{online}</p>
        </div>
        <div className="bg-sand-50 px-5 py-4 ring-1 ring-ink-900/10">
          <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-600/60">
            Front desk / walk-in
          </p>
          <p className="mt-2 font-display text-3xl font-light text-ink-900">{walkInish}</p>
        </div>
      </div>
    </div>
  );
};

export default TillSummary;
